import loadable from 'react-loadable';

export default loadable({
    loader: () =>
        import(
            /* webpackChunkName: "mobile-search-sheet" */
            './MobileSearchSheet'
        ),
    loading: () => null,
});
